import { FaItemRoot } from "./FaItemRoot/FaItemRoot";
import { FaItemLabel } from "./FaItemLabel/FaItemLabel";
import { FaItemContent } from "./FaItemContent/FaItemContent";
import { FaItemTrailing } from "./FaItemTrailing/FaItemTrailing";

export const Root = FaItemRoot;
export const Label = FaItemLabel;
export const Content = FaItemContent;
export const Trailing = FaItemTrailing;
